import { API_URL } from "../config/connect";

const headers = () => ({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem("access_token")}`,
});

export async function getDealerEmployees() {
    const response = await fetch(`${API_URL}/api/v1/dealer/employees`, {
        headers: headers(),
    });
    if (!response.ok) throw new Error(response.statusText);
    return response.json();
}

export async function addDealerEmployee(employee) {
    // employee: { name, dealer_role, iin, phone }
    const response = await fetch(`${API_URL}/api/v1/dealer/employees`, {
        method: 'POST',
        headers: headers(),
        body: JSON.stringify(employee),
    });
    if (!response.ok) throw new Error(response.statusText);
    return response.json();
}

export async function deleteDealerEmployee(employeeId) {
    const response = await fetch(`${API_URL}/api/v1/dealer/employees/${employeeId}`, {
        method: 'DELETE',
        headers: headers(),
    });
    if (!response.ok) throw new Error(response.statusText);
}
